import React from 'react'

function NumberInput({ setQty, qty, maxQty, disabled }) {

  const validateQtyKeypress = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  }

  const handleChangeQty = ({ target: { value } }) => {
    if (value && value < maxQty) {
      setQty(value)
    } else {
      setQty(maxQty)
    }
  }

  const handleAddQty = () => {
    qty = qty && parseInt(qty)
    if (qty < maxQty)
      setQty(qty + 1)
  }

  const handleDecQty = () => {
    qty = qty && parseInt(qty)
    if (qty > 0) {
      setQty(qty - 1)
    }
  }

  return (
    <div>
      <div className={`flex border-2 border-slate-200 rounded-lg w-36 justify-evenly ${disabled && 'bg-slate-200'}`}>
        <button disabled={disabled} onClick={handleDecQty} className="flex justify-center w-8">
          <span className="text-3xl font-bold select-none">-</span>
        </button>
        <input disabled={disabled} onKeyPress={validateQtyKeypress} onChange={handleChangeQty} value={qty} type="number" min="0" className="block w-10 py-2 text-center text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:text-sm sm:leading-6" placeholder="0" />
        <button disabled={disabled} onClick={handleAddQty} className="flex items-center justify-center w-8">
          <span className="text-2xl font-bold select-none">+</span>
        </button>
      </div>
    </div>
  )

}

export default NumberInput